// 假期管理的 接口集合
import request from '../request.js'

// 假期管理-分页查询假期列表 --- 刘献根
export const getHolidayList = function (data) {
    return request({
        url: 'operateHoliday/getHolidayList',
        method: 'post',
        data
    })
}

// 假期管理-新增假期 --- 刘献根
export const saveHoliday = function (data) {
    return request({
        url: 'operateHoliday/saveHoliday',
        method: 'post',
        data
    })
}

// 假期管理-删除假期 --- 刘献根
export const deleteHoliday = function (data) {
    return request({
        url: 'operateHoliday/deleteHoliday',
        method: 'post',
        data
    })
}